module.exports = __webpack_public_path__ + "img/c289760.png";